import { useState, useRef, useEffect, useCallback } from 'react';

const AlarmState = {
	Off: 0,
    Started: 1,
	VisualAlarm: 2,
	AudioAlarm: 3,
    EmergencyMeasure: 4
};

const AlarmTime = [null ,5000, 2000, 10000, null]; // Time to the next state.

export default function useActivityTimer(enable, vehicleId, sendToInfrastructure) {

    const startTimeRef = useRef(null);
    const timerIdRef = useRef(null);
    const [level, setLevel] = useState(false);

    const escalate = useCallback((alarmLevel) => {
        if(enable) {
            console.log(`escalate to level ${alarmLevel}`);
            setLevel(alarmLevel);
            if(alarmLevel < AlarmState.EmergencyMeasure) {
                timerIdRef.current = window.setTimeout(() => {escalate(alarmLevel + 1);}, AlarmTime[alarmLevel]);
            } else {
                sendToInfrastructure(vehicleId, 'updateVehicleStateRequest', {state: 'emergency'});
            }
        }
    }, [setLevel, vehicleId, sendToInfrastructure, enable]);

    const refresh = useCallback(() => {
        if(timerIdRef.current) {
            window.clearTimeout(timerIdRef.current);
        }
        startTimeRef.current = Date.now();
        escalate(AlarmState.Started);
    }, [escalate]);

    useEffect(() => {
        if(enable) {
            refresh();
        } else {
            setLevel(AlarmState.Off);
            startTimeRef.current = null;
        }
        return () => {
            window.clearTimeout(timerIdRef.current);
            timerIdRef.current = null;
        }
    }, [enable, setLevel, refresh]);

    return {refresh, level, startTimeRef};

}
